import { inject, injectable } from 'tsyringe';
import { NoRecommendationsReasons } from '../no-recommendations-reasons.enums';
import { ICondition, MatchResult } from './interfaces/condition.interface';
import { ConditionContext } from './interfaces/condition-context.interface';
import { Application } from '../../../models/application.model';
import {
  conditionType,
  ConditionType,
} from './decorators/condition-type.decorator';
import { LoggerService } from '../../logger.service';
import { kDITOWExtensionWrapper } from '../../../constants/injectionTokens';
import { IOWExtensionWrapper } from '../../../interfaces/ow-wrappers/ow-extension-wrapper.interface';

// -----------------------------------------------------------------------------
@injectable()
@conditionType(ConditionType.AppSpecific)
export class ConditionApplicationAlreadyInstalled implements ICondition {
  private readonly logger = LoggerService.getCategory(
    'ConditionApplicationAlreadyInstalled',
  );

  // ---------------------------------------------------------------------------
  public constructor(
    @inject(kDITOWExtensionWrapper)
    private readonly owExtensionWrapper: IOWExtensionWrapper,
  ) {}

  // ---------------------------------------------------------------------------
  // ICondition
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  public get id(): string {
    return this.logger.name;
  }

  // ---------------------------------------------------------------------------
  async match(context: ConditionContext): Promise<MatchResult> {
    const { application } = context;

    const match = await this.nonInstalledExtensionsFound(application);

    const matchReason = match
      ? null
      : NoRecommendationsReasons.SpecificApplicationAlreadyDownloaded;

    return [match, matchReason];
  }

  // ---------------------------------------------------------------------------
  private async nonInstalledExtensionsFound(
    recommendedApp: Application,
  ): Promise<boolean> {
    const downloadedExtensions =
      await this.owExtensionWrapper.getInstalledAndEnabledExtensionUids();

    if (!downloadedExtensions) {
      return true;
    }

    for (let i = 0; i < downloadedExtensions.length; i++) {
      if (downloadedExtensions[i] === recommendedApp.uid) {
        this.logger.info(`Application ${recommendedApp.uid} already Installed`);
        return false;
      }
    }

    return true;
  }
}
